import { Crop as CropIcon } from '@mui/icons-material';
import { Alert, Button } from '@mui/material';
import React from 'react';
import CropAdjustDialog from './CropAdjustDialog';
import type { useHeroImageCropAdjust } from './useHeroImageCropAdjust';

/** The "Adjust crop" button, its error and its dialog — shown only when the crop can be adjusted. */
export default function HeroImageCropControls({
  crop,
  label,
}: {
  crop: ReturnType<typeof useHeroImageCropAdjust>;
  label: string;
}) {
  return (
    <>
      {crop.canAdjust && (
        <Button
          size="small"
          startIcon={<CropIcon fontSize="small" />}
          onClick={crop.openDialog}
          disabled={crop.busy}
          sx={{ mt: 1 }}
        >
          Adjust crop
        </Button>
      )}
      {crop.error && (
        <Alert severity="error" sx={{ mt: 1 }}>
          {crop.error}
        </Alert>
      )}
      {/* Mounted on open so the canvas starts from the current box. */}
      {crop.open && (
        <CropAdjustDialog
          variant="hero"
          open
          source={crop.meta?.source ?? null}
          initialBoxes={crop.meta?.boxes ?? []}
          headings={[label]}
          busy={crop.busy}
          onApply={(boxes) => void crop.apply(boxes)}
          onCancel={crop.closeDialog}
        />
      )}
    </>
  );
}
